module.exports = __webpack_public_path__ + "img/macStep4.2a9e9bcf.png";